export default __webpack_public_path__ + "static/media/bubble_nova_grid_xl.76021932.jpg";